module.exports = __webpack_public_path__ + "img/value-props-brand-2.95a82500.jpg";